export const formatDateToYYYYMM = (date: Date | null): string => {
  if (!date) {
    return "" // null일 경우 빈 문자열 반환
  }
  const year = date.getFullYear() // 연도 가져오기
  const month = String(date.getMonth() + 1).padStart(2, "0") // 월은 0부터 시작하므로 +1, 두 자리로 포맷팅
  return `${year}-${month}`
}
